// マイカーリース・新車購入ページのプランメニューボタン専用スクリプト
$(document).ready(function () {
  let url = location.pathname;
  let $btn = null;

  switch (url) {
    case '/smart-plan/':
      $btn = $('.js-smart-plan-btn');
      break;

    case '/lease-7/':
      $btn = $('.js-lease-7-btn');
      break;

    case '/newcar/':
      $btn = $('.js-newcar-btn');
      break;

    default:
      // 該当ページ以外では何もしない
      return;
  }

  if ($btn.length) {
    $btn.addClass('open');
  }
});
